export default {
    "0":"Whole",
    "1":"Per Person",
    "2":"Per Hours",
    "3":"Per KG",
    "4":"Per Box",
    "5":"Per Piece",
}

